import { utils } from '@yola/ws-sdk';
import validateProtocol from './validate-protocol';

const isSocialLinkUrlValid = (value) =>
  validateProtocol(value) || utils.validation.isFullyURL(value.trim());

export default isSocialLinkUrlValid;
